export const MENU_VISIBLE = "MenuVisible_v1";
export const AI_COMMENT_COUNT = "aiCommentCount_v1";
export const STUDY_COMMENT_COUNT = "studyCommentCount_v1";
// 律师来源数据
export const LAWYER_SOURCE = "LawyerSource_v1";
// 合同生成 老用户提示
export const CONTRACT_OLD_USER_TIP = "ContractOldUserTip_v1";
// 文书生成引导
export const DOCUMENT_GUIDE = "DocumentGuide_v1";
// 深度思考
export const DEEPSEEK_IS = "deepseekIs_v1";
// 法搜 VIP 弹窗确认
export const LOCAL_STORAGE_KEY = "DATA_VIP_MODAL_CONFIRM";
// 合同生成模板开关状态
export const CONTRACT_GENERATE_TEMPLATE_STATUS = "ContractGenerateTemplateStatus_v1";
